import React from "react";
import { Doughnut } from "react-chartjs-2";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const DeviceAnalysisChart = () => {
    const data = {
        labels: ["Desktop", "Tablet", "Mobile"],
        datasets: [
            {
                label: "Device Usage",
                data: [30, 50, 20],
                backgroundColor: ["#AC4290", "#6d4dbf", "#cc6ea0"],
                borderColor: "#fff",
                borderWidth: 4,
                borderRadius: 10,
                hoverBackgroundColor: undefined,
                hoverBorderColor: undefined,
                hoverBorderWidth: 0,
                hoverOffset: 0,
            },
        ],
    };

    const options = {
        cutout: "40%", // central hole size in doughnut
        plugins: {
            legend: {
                position: "bottom",
                labels: {
                    usePointStyle: true,
                    pointStyle: "circle",
                    padding: 20,
                    font: {
                        size: 14,
                        weight: "500"
                    },
                    color: "#333",
                },
            },
            tooltip: {
                enabled: true, // ❌ Turn off tooltip if you also don't want hover values
            },
            datalabels: {
                display: false, // ⛔ Explicitly disable data labels if plugin is registered
            },
            tooltip: {
                backgroundColor: "#333",
                titleColor: "#fff",
                bodyColor: "#eee",
                borderColor: "#999",
                borderWidth: 4,
            }
        },
        responsive: true,
        maintainAspectRatio: false,
    };

    return (
        <div className=" p-3" style={{ width: "100%", maxWidth: "400px", height: "320px" }}>

            <Doughnut data={data} options={options} />
        </div>
    );
};

export default DeviceAnalysisChart;
